var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner",style:({'backgroundImage':'url('+_vm.bannerBg+')'})},[_c('div',{staticClass:"banner-title"},[_vm._v(_vm._s(_vm.getBannerTitle))]),_c('div',{staticClass:"detail-rule"},[_c('OldCusterRule')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }